import { useMemo } from "react";
import { useTheme } from "../hooks/use-theme";
import { Image, StyleSheet, View } from "react-native";
import VStack from "../ui_atoms/VStack";
import MarkdownView, { MarkdownTextProps } from "./MarkdownView";

const LIFT_PERSON_NAME = "Amélie";

type LiftPersonProps = {
    markdownProps?: MarkdownTextProps;
};

export const LiftPerson = ({ markdownProps }: LiftPersonProps) => {
    const styles = useStyles();

    return (
        <VStack gap="2/3">
            <Image style={styles.image} source={require("../assets/images/lift_person.png")} />
            {markdownProps?.markdown && (
                <View style={styles.bubble}>
                    <View style={styles.arrow} />
                    <MarkdownView
                        {...markdownProps}
                        markdown={`${markdownProps.markdown}\n\n**${LIFT_PERSON_NAME}**`}
                    />
                </View>
            )}
        </VStack>
    );
};

const IMAGE_SIZE = 82;
const ARROW_SIZE = 14;

const useStyles = () => {
    const { colors, gridSize, roundness } = useTheme();

    return useMemo(
        () =>
            StyleSheet.create({
                image: {
                    width: IMAGE_SIZE,
                    height: IMAGE_SIZE,
                    borderRadius: IMAGE_SIZE / 2,
                    borderWidth: 4,
                    borderColor: colors.background,
                },
                arrow: {
                    position: "absolute",
                    top: -4,
                    left: 34,
                    width: ARROW_SIZE,
                    height: ARROW_SIZE,
                    backgroundColor: colors.background,
                    transform: [{ rotate: "45deg" }],
                    borderRadius: roundness / 4,
                },
                bubble: {
                    paddingHorizontal: gridSize / 2,
                    paddingVertical: gridSize / 3,
                    borderRadius: roundness * 2,
                    backgroundColor: colors.background,
                    maxWidth: 700,
                },
            }),
        [colors.background, gridSize, roundness],
    );
};
